export const selectProfileLoading = (state) => state.profile.loading;
export const selectProfileInfo = (state) => ({
  firstName: state.profile.firstName,
  secondName: state.profile.secondName,
  publicUrlName: state.profile.publicUrlName,
  email: state.profile.email,
  about: state.profile.about,
  avatar: state.profile.avatar,
})
export const selectProfileUrl = (state) => state.profile.publicUrlName
export const selectStripeAccountErrors = (state) => state.profile.stripeAccountErrors
export const selectStripeAccountLink = (state) => state.profile.stripeAccountLink;
